(function () {
  function announcementSlider() {
    $(".announcement-bar__slide").each(function () {
      const $slider = $(this);

      // Evita di inizializzare più volte lo stesso slider
      if ($slider.hasClass("slider_started")) {
        return;
      }

      const swiperElement = $slider.find(".swiper")[0];

      // Verifica che Swiper sia effettivamente disponibile
      if (!swiperElement || typeof Swiper === "undefined") {
        console.warn("Swiper non è disponibile oppure lo slider non è stato trovato.");
        return;
      }

      const speed = (parseFloat($slider.data("announcement-speed")) || 0.5) * 1000;
      const delay = (parseFloat($slider.data("announcement-delay")) || 3) * 1000;
      const slidesCount = $slider.find(".swiper-slide").length;

      const swiperConfig = {
        slidesPerView: 1,
        speed: speed,
        loop: slidesCount > 1,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        allowTouchMove: slidesCount > 1
      };

      // L'autoplay viene attivato solo se esiste una seconda slide
      if (slidesCount > 1) {
        swiperConfig.autoplay = {
          delay: delay,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        };
      }

      new Swiper(swiperElement, swiperConfig);

      $slider.addClass("slider_started");
    });
  }

  document.addEventListener("DOMContentLoaded", announcementSlider);

  // Necessario nel Theme Editor Shopify quando ricarichi/modifichi una sezione
  document.addEventListener("shopify:section:load", announcementSlider);

  document.addEventListener("visibilitychange", function () {
    $(".announcement-bar__slide.slider_started").each(function () {
      const swiperElement = $(this).find(".swiper")[0];

      if (!swiperElement || !swiperElement.swiper || !swiperElement.swiper.autoplay) {
        return;
      }

      if (document.hidden) {
        swiperElement.swiper.autoplay.stop();
      } else {
        swiperElement.swiper.autoplay.start();
      }
    });
  });
})();